import ConfirmDialog from './index.vue'
import { h, render } from 'vue'

export default {
  install (app) {
    /**
     * @param {string} title 标题
     * @param {string} content 内容
     * @param {object} options 配置
     * @param {string} options.confirmText 确认按钮文本
     * @param {string} options.cancelText 取消按钮文本
     * @param {boolean} options.closeOnClickModal 点击模态框是否关闭
     * @param {boolean} options.closeOnPressEscape 按下 ESC 键是否关闭
     * @param {function} options.onConfirm 确认回调
     * @param {function} options.onCancel 取消回调
     */
    const showConfirmDialog = (title, content, options = {}) => {
      return new Promise((resolve, reject) => {
        // 创建容器
        const container = document.createElement('div')
        document.body.appendChild(container)

        const close = () => {
          render(null, container)
          container.remove()
        }

        const vnode = h(ConfirmDialog, {
          title,
          content,
          confirmText: options.confirmText || 'Confirm',
          cancelText: options.cancelText || 'Cancel',
          showCancelButton: options.showCancelButton ?? true,
          closeOnClickModal: options.closeOnClickModal ?? true,
          closeOnPressEscape: options.closeOnPressEscape ?? true,
          modelValue: false,
          onConfirm: () => {
            if (options.onConfirm) {
              options.onConfirm()
            }
            resolve('confirm')
            setTimeout(() => {
              close()
            }, 300)
          },
          onCancel: () => {
            if (options.onCancel) {
              options.onCancel()
            }
            reject('cancel')
            setTimeout(() => {
              close()
            }, 300)
          },
          onClose: () => {
            close()
          }
        })

        render(vnode, container)
      })
    }

    // 提供全局方法
    app.config.globalProperties.$confirm = showConfirmDialog
  }
}
